import { IURLsObject } from '@interfaces/routes';

const urls: IURLsObject = {
  adminHome: '/admin',
  adminInquiries: '/admin/inquiries',
  disclaimer: '/disclaimer',
  faq: '/faq',
  home: '/',
  inquiries: '/inquiries',
  inquiryDetails: '/dietary-supplement-inquiry/:inquiryId',
  inquiryDraft: '/dietary-supplement-inquiry',
  inquiryResponse: '/dietary-supplement-inquiry-response/:inquiryId',
  highRiskSupplements: '/high-risk-supplements',
  login: '/login',
  medications: '/medication-status-lookup',
  medicationsInquiryDetails: '/medication-status-lookup/:inquiryId',
  medicationsInquiryResponse: '/medication-status-lookup-response/:inquiryId',
  printInquiryResponse: '/dietary-supplement-inquiry-response/:inquiryId/print',
  printInquiryMedicationResponse: '/medication-status-lookup-response/:inquiryId/print',
  profile: '/profile',
  sharedInquiryResponse: '/shared/:sharedInquiryResponseId',
  category: '/category/:categoryId',
  resource: '/resource/:resourceId',
  infoPage: 'info-page',
};

export default urls;
